import React from 'react';

import CardDialog from '~/components/CardDialog';
import EmptyState from '~/components/core/EmptyState';
import LoadingSwitch from '~/components/core/Loading/LoadingSwitch';

import { useSopConfiguration } from './hooks/useSopConfiguration';
import SopViewDialogContent from './SopViewDialogContent';

interface SubOrgSopViewDialogProps {
  open: boolean;
  onClose: () => void;
  subOrganizationId: number;
  subOrganizationName: string;
}

const SubOrgSopViewDialog: React.FC<SubOrgSopViewDialogProps> = ({
  open,
  onClose,
  subOrganizationId,
  subOrganizationName,
}) => {
  const { configuration, isLoading, isError } = useSopConfiguration({
    subOrganizationId,
    enabled: open,
  });

  if (!open) return null;

  const title = `${subOrganizationName} Standard Operating Procedures`;

  return (
    <CardDialog
      isDialog
      open={open}
      onClose={onClose}
      title={title}
      maxWidth={false}
      PaperProps={{
        style: { height: '70vh', width: '70vw' },
      }}
    >
      <LoadingSwitch isLoading={isLoading} isError={isError}>
        {/* The SOP GET answers 204 when there is none, which leaves `configuration` null - reachable
            whenever the row's SOP status was unknown and this dialog was opened anyway. Without this
            the dialog renders a title over a blank body and reads as a broken screen. */}
        {configuration ? (
          <SopViewDialogContent configuration={configuration} />
        ) : (
          <EmptyState
            title="No SOP configured"
            subtitle="This sub-organization has no Standard Operating Procedures yet."
            className="p-24"
          />
        )}
      </LoadingSwitch>
    </CardDialog>
  );
};

export default SubOrgSopViewDialog;
